/* eslint-disable no-param-reassign */
/* eslint-disable no-multi-assign */
/* eslint-disable react/no-danger */
/* eslint-disable no-console */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import { NotificationsOffOutlined, NotificationsOutlined } from '@material-ui/icons';
import {
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledButtonDropdown,
  Col, Card, CardBody, CardTitle
} from 'reactstrap';
import styles from '../../AirfieldsConditions/components/airport-information/airportinfo.module.scss';
import Spinner from '../../../components/spinner';
import 'bootstrap/dist/css/bootstrap.min.css';
import './PortalTile.scss';
import { postPortalTilesList, fetchPortalTilesList } from '../redux/actions';

const PortalTile = ({ data, actionPostPortile, actionGetFetchData }) => {
  const [tileInfo, setTileInfo] = useState('');
  const [loadingStatus, setLoadingStatus] = useState(false);
  useEffect(() => {
    setLoadingStatus(true);
    fetchTileData(data.attachment[0].url);
  }, []);

  const fetchTileData = (url) => {
    axios
      .get(url, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(
        (response) => {
          setLoadingStatus(false);
          setTileInfo(response.data);
        },
        (error) => {
          setLoadingStatus(false);
          console.log(error);
        }
      );
  };

  const handleSubscribe = async (objs) => {
    actionGetFetchData();
    const dataObj = (data.subscribed = !data.subscribed);
    const object = { Subscribe: dataObj };
    actionPostPortile(objs.id, object);
  };
  useEffect(() => {
    actionGetFetchData();
  }, []);

  let info = tileInfo.replaceAll('&lt;', '<');
  info = info.replaceAll('&gt;', '>');
  return (
      <Col className="p-0" style={{ height: '100%' }}>
        <Card className="styles.airportInfoCard" style={{ height: '100%' }}>
          <CardTitle
            className={`${styles.portaltilesCardTitle} d-flex mr-2 align-items-center`}
            style={{ justifyContent: 'space-between' }}
          >
            <div className={styles.tileHeading}>{data.tile_name}</div>
            <div className={styles.tileHeading}>
              <UncontrolledButtonDropdown>
                <DropdownToggle className="btnToggle">
                  <MoreHorizIcon />
                </DropdownToggle>
                <DropdownMenu style={{ zIndex: 99, transform: 'translate3d(-95px, 38px, 0px)', top: 0 }}>
                  <DropdownItem
                    onClick={() => handleSubscribe(data)}
                    className="activeClick" style={{ zIndex: 99 }}
                  >
                    {data.subscribed ? (
                      <span className="text-danger fw-bold">
                        <NotificationsOffOutlined />
                        {' '}
                        Unsubscribe
                      </span>
                    ) : (
                      <span className="text-muted fw-bold">
                        <NotificationsOutlined />
                        {' '}
                        Subscribe
                      </span>
                    )}
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledButtonDropdown>
            </div>
          </CardTitle>
          <CardBody>
            <Spinner large active={loadingStatus} />
            <Col lg={12} className={styles.airportinformationcard} style={{ maxHeight: '10%' }}>
              <div className={styles.airportinformation} />
            </Col>
            {tileInfo && (
            <Col lg={12} className={styles.airportInfoCardDetail} style={{ height: '90%' }}>
              <div className="content" dangerouslySetInnerHTML={{ __html: info }} />
            </Col>
            )}
          </CardBody>

        </Card>
      </Col>
  );
};
const mapStateToProps = state => ({
  dataList: state.home.portalTilesList
});
const mapDispatchToProps = dispatch => ({
  actionPostPortile: (id, data) => {
    dispatch(postPortalTilesList(id, data));
  },
  actionGetFetchData: () => {
    dispatch(fetchPortalTilesList());
  }
});
export default connect(mapStateToProps, mapDispatchToProps)(PortalTile);
